// @ts-ignore
import i18n_legacy from "@cirrus/legacy/app-common/alt/framework/i18n.js";

/**
 * @deprecated This should not be used
 */
export const i18n = (key: string): string => {
  return i18n_legacy(key)
}
